import { RoundupTypeEnum } from '@repo/supergraph/base/enums';
import type { FeatureFlag } from './types';

export const ALL_SLUG = 'all';

export enum FeatureFlagName {
  apyInPaidRoundupTitle = 'apy_in_paid_title',
  cdRatesRoundupRedesign = 'cd_rates_roundup_redesign',
  hysaCalculator = 'hysa_calculator',
  hysaVsNationalAvgBanner = 'hysa_vs_national_avg_banner',
  productionalizeMobileFirstSummaryTable = 'productionalize_mobile_first_summary_table',
  seoBankingRoundupRank = 'banking_rank_roundup_changes',
  showLessMonetizingOffers = 'show_less_monetizing_offers',
  showSevenOffersInSummaryTable = 'show_seven_offers_in_summary_table',
  simplifiedPaidHeader = 'simplified_paid_header',
  /** the style updates are the following: (new star rating with icon, centered driver columns, tighter spacing in header and advertiser disclosure moved to top right0 */
  stylingUpdates = 'styling_updates',
  bankBonusesFiltersLayout = 'bank_bonuses_filters_layout',
}

/**
 * Roundup features
 *
 * @key  Roundup features
 * @value Features enabled for banking roundup slug(s) or 'all' for all Banking Roundups
 */
export const ROUNDUP_FEATURES: Record<string, FeatureFlag> = {
  [FeatureFlagName.seoBankingRoundupRank]: {
    audience: [{ mode: 'slug', slugs: ['all'], pageType: RoundupTypeEnum.ORGANIC_ROUNDUP }],
    lifecycle: 'temporary',
  },
  [FeatureFlagName.apyInPaidRoundupTitle]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['standout-high-yield-savings-products', 'standout-high-yield-savings-products-b'],
      },
    ],
    lifecycle: 'permanent',
  },
  [FeatureFlagName.cdRatesRoundupRedesign]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['cd-rates-redesign', 'cd-rates'],
      },
    ],
    lifecycle: 'temporary',
  },
  [FeatureFlagName.productionalizeMobileFirstSummaryTable]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['bank-bonuses-and-promotions'],
      },
    ],
    lifecycle: 'temporary',
  },
  [FeatureFlagName.hysaCalculator]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['high-yield-online-savings-accounts'],
      },
    ],
    lifecycle: 'permanent',
  },
  [FeatureFlagName.hysaVsNationalAvgBanner]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['high-yield-online-savings-accounts'],
        targetDeviceType: 'desktop',
      },
    ],
    lifecycle: 'permanent',
  },
  [FeatureFlagName.simplifiedPaidHeader]: {
    audience: [
      {
        targetDeviceType: 'mobile',
        mode: 'group',
        slugs: ['standout-cd-rates', 'standout-online-checking-accounts'],
      },
    ],
    lifecycle: 'permanent',
  },
  [FeatureFlagName.showLessMonetizingOffers]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['checking-accounts', 'online-checking-accounts'],
        targetDeviceType: 'mobile',
      },
    ],
    lifecycle: 'temporary',
  },
  [FeatureFlagName.showSevenOffersInSummaryTable]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['bank-bonuses-and-promotions'],
      },
    ],
    lifecycle: 'permanent',
  },
  [FeatureFlagName.bankBonusesFiltersLayout]: {
    audience: [{ mode: 'slug', slugs: ['bank-bonuses-and-promotions'] }],
    lifecycle: 'permanent',
  },
  [FeatureFlagName.stylingUpdates]: {
    audience: [
      {
        mode: 'slug',
        slugs: ['standout-high-yield-savings-accounts-ntv-quality-cash'],
      },
      {
        mode: 'group',
        slugs: [
          'standout-high-yield-savings-products',
          'standout-online-checking-accounts',
          'standout-high-yield-accounts',
          'standout-cd-rates',
          'standout-high-yield-savings-ntv',
        ],
      },
    ],
    lifecycle: 'permanent',
  },
};
